import http from '../http-common';

class CategoryMasterDataService {
  getAll() {
    return http.get("/category");
  }

  get(id) {
    return http.get(`/category/edit/${id}`);
  }

  create(data) {
    return http.post("/category/add", data);
  }

  update(data) {
    return http.put(`/category/update`, data);
  }

  delete(id) {
    return http.put(`/category/delete/${id}`);
  }
}

export default new CategoryMasterDataService();
